import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APIOtp {

  getUrlDomain(nome_metodo)
  {

    let result = "";

    if (location.hostname == "localhost") {
        result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = "https://companysupport.eu/";

    }

    return result + nome_metodo;


  }

  getUrlDomainGo(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = "http://localhost:4007/";
    }

    if (location.hostname != "localhost") {

      result = "https://filestransfer.it:4007/";

    }

    return result + nome_metodo;


  }


  async generateOTPAndSendMail(user, name_product, tipo_op, id)
  {

    let formData = new FormData();

    formData.append("username",  user);
    formData.append("name_product",  name_product);
    formData.append("tipo_op",  tipo_op);
    formData.append("v_id",  id);
    
    return axios.post(this.getUrlDomain("generateOtpAndSendMail") , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

  }

  async generateOTPAndSendMailLogin(user, name_product, tipo_op, id)
  {

    let formData = new FormData();

    formData.append("username",  user);
    formData.append("name_product",  name_product);
    formData.append("tipo_op",  tipo_op);
    formData.append("v_id",  id);
    
    return axios.post(this.getUrlDomain("generateOtpAndSendMailLoginCandidate") , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

  }


  async generateOTPAndSendMailLoginGo(user, name_product, tipo_op, id)
  {

    let formData = new FormData();

    formData.append("username",  user);
    formData.append("name_product",  name_product);
    formData.append("tipo_op",  tipo_op);
    formData.append("v_id",  id);
    
    return axios.post(this.getUrlDomainGo("generateOtpAndSendMail") , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

  }


  async generateOTPAndSendMailSendCV(email, name_product, tipo_op, companyid)
  {

    let formData = new FormData();

    formData.append("email",  email);
    formData.append("name_product",  name_product);
    formData.append("tipo_op",  tipo_op);
    formData.append("companyid",  companyid);
    
    return axios.post(this.getUrlDomain("generateOTPAndSendMailSendCV") , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

  }

  async removeAccount(user)
  {

    let formData = new FormData();

    formData.append("username",  user);
    
    return axios.post(this.getUrlDomainGo("removeAccount") , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

  }





}

export default new APIOtp({
  url: "https://services.ebadge.it/public/api/"
})
